import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const verifyOrganisationFinanceMutation = gql`
  mutation (
    $customerId: String!
    $subjectId: String!
    $request: VerifyOrganisationFinanceInput!
    $userId: String!
  ) {
    verifyOrganisationFinance(
      customerId: $customerId
      subjectId: $subjectId
      request: $request
      userId: $userId
    )
  }
`

export type MutationVars = {
  customerId: string
  subjectId: string
  userId: string
  request: VerifyOrganisationFinanceRequest
}

export interface VerifyOrganisationFinanceRequest {
  assets: number
  liabilities: number
  unrestrictedFunds: number
  cashAndEquivalent: number
}

export type VerifyOrganisationFinanceData = {
  verifyOrganisationFinanceData: string | unknown
}

export const useVerifyOrganisationFinanceMutation: WrappedMutation<
  VerifyOrganisationFinanceData,
  MutationVars
> = () =>
  useMutation<VerifyOrganisationFinanceData, MutationVars>(
    verifyOrganisationFinanceMutation,
    {
      client: agentClient,
    },
  )
